module.exports = __webpack_public_path__ + "img/profile.4ea7cb2d.svg";